module.exports = {
  mmRomance: {
    label: 'M/Mロマンス小説',
    description:
      '引き込まれる骨太なストーリーと、男たちのときめくロマンスが同時に楽しめる海外版のBL小説。悶えながら英語も勉強できるなんて、最高の教科書じゃないですか。',
  },
  blManga: {
    label: 'BLマンガ',
    description:
      '毎月大量のBLマンガを購入しているジーナが、読了後に放心状態になるような、本当におススメする作品だけをご紹介します。ストーリー重視。',
  },
  tvMovie: { label: 'TV･映画', description: 'ゲイロマンス映画やドラマを中心に、突き刺さった作品をご紹介します。' },
  english: {
    label: '英語学習',
    description:
      '帰国子女でもなければ、大学受験もしていない英語嫌いだったジーナが、中学英語から勉強し直し、カナダで仕事をし、生活できるようになった英語学習法など。',
  },
  misc: {
    label: 'ちょっと小話',
    description:
      'M/Mロマンス小説でもBLマンガでもない、割と真面目に書いた記事たち。日々思ったことを無秩序に綴っています。',
  },
  podcast: {
    label: 'ポッドキャスト',
    description: 'ゆるゆると語ってます。',
  },
  vocabulary: {
    label: '単語帳',
    description: '',
  },
}
